import React, { Fragment, useState } from "react";
import { v4 as uuidv4 } from "uuid";

const Formulario = ({crearCita}) => {
  //crear el state de citas
  const [cita, actualizarCita] = useState({
    mascota: "",
    propietario: "",
    fecha: "",
    hora: "",
    sintomas: "",
  });
  const [error, actualizarError] = useState(false);

  //funcion que se ejecuta para leer los datos de los inputs
  const actualizarState = ({ target }) => {
    const { name, value } = target;
    const field = { [name]: value };
    const _cita = {
      ...cita,
      ...field,
    };
    actualizarCita(_cita);
  };

  //extraer los valores
  const { mascota, propietario, fecha, hora, sintomas } = cita;

  //enviar el formulario
  const submitCita = (e) => {
    e.preventDefault();
    //validar el formulario
    let cancel = false;
      for (const key in cita) {
      if (cita[key].trim() === "") {
        cancel = true;
      }
    }
    if (cancel) {
      actualizarError(true);
      return false;
    }
    //eliminar el mensaje previo
    actualizarError(false);

    //Asignar un ID
      cita.id = uuidv4(); 

      //crear cita
      crearCita(cita);
      //reiniciar el formulario
      actualizarCita({
        mascota: "",
        propietario: "",
        fecha: "",
        hora: "",
        sintomas: "",
      })
  };
  return (
    <Fragment>
      <h2>Crear Cita</h2>

      {error ? (
        <p className="alerta-error">Todos los Campos son Obligatorios</p>
      ) : null}
      <form id={"create-course-form"} onSubmit={submitCita}>
        <label>Nombre Mascota</label>
        <input
          type="text"
          name="mascota"
          className="u-full-width"
          placeholder="Nombre Mascota"
          onChange={actualizarState}
          value={mascota}
        />
        <label>Nombre Dueño</label>
        <input
          type="text"
          name="propietario"
          className="u-full-width"
          placeholder="Nombre Dueño de la Mascota"
          onChange={actualizarState}
          value={propietario}
        />
        <label>Fecha</label>
        <input
          type="date"
          name="fecha"
          className="u-full-width"
          onChange={actualizarState}
          value={fecha}
        />
        <label>Hora</label>
        <input
          type="time"
          name="hora"
          className="u-full-width"
          onChange={actualizarState}
          value={hora}
        />
        <label>Sintomas</label>
        <textarea
          className="u-full-width"
          name="sintomas"
          onChange={actualizarState}
          value={sintomas}
        ></textarea>
        <button className="u-full-width button-primary" type="submit">
          Agregar Cita
        </button>
      </form>
    </Fragment>
  );
};

export default Formulario;
